/**
 * NotificationEmptyState — Surface Layer (/01).
 *
 * Presentational empty state for the notifications panel, modeled on the
 * IBM Products `NotificationsPanel` empty-state pattern (Carbon for IBM
 * Products) and composed locally from a `@carbon/react` Tile + the shared
 * `view-empty` global class. Strictly presentational; copy varies by filter.
 */

import { Tile } from '@carbon/react';
import { Notification } from '@carbon/icons-react';
import '../../styles/views.scss';
import './notifications-panel.scss';

export interface NotificationEmptyStateProps {
  /** Which filter produced the empty result, so copy can be tailored. */
  filter: 'all' | 'unread';
}

export function NotificationEmptyState({ filter }: NotificationEmptyStateProps) {
  const heading = filter === 'unread' ? "You're all caught up" : 'No notifications yet';
  const detail =
    filter === 'unread'
      ? 'There are no unread notifications. New approvals and updates will appear here.'
      : 'Approvals, reports and agentic actions will appear here once they arrive.';

  return (
    <Tile className="view-empty">
      <Notification size={24} aria-hidden="true" />
      <h3>{heading}</h3>
      <p className="view-tile__label">{detail}</p>
    </Tile>
  );
}
